<template>
<div class="row about-brig" id="aboutBrig">
    <div class="col-md-4">
        <img v-if="detail && detail.pic" :src="detail.pic.url" class="img-fluid">
    </div>
    
    <div class="col-md-8 whatis-brigadeiro" v-if="detail && detail.text">
        <div class="title-bar"></div>
        <h2>What is Brigadeiro?</h2>
        <p v-for="text of detail.text" :key="text.id">
            {{text.text}}
        </p>
        
    </div>
</div>
</template>
<script>
export default {
    name: 'About',
    props: ['detail']    
    }
</script>
<style lang="scss">
.title-bar {
    width: 75px;
    height: 15px;
    background-color: #C52D6C;
    margin-bottom: 10px;
}
.about-brig {
    margin-left: 0px;
    margin-right: 0px;
    .col-md-4 {
        padding: 0;
    }
}
.whatis-brigadeiro {
    h2 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        color: #300B02;
    }
    p {
        color: #603913;
        font-size: 15pt;
    }
    padding: 50px;
}
</style>